/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node, format } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IChurchUnitBillingEntity, IChurchRetailChannelEntity } from '../../actions/DataServiceEntities.g';
import Select from 'react-select';
import { ICheckoutState } from '@msdyn365-commerce/global-state';
//@ts-ignore
import { Info, Error } from '@churchofjesuschrist/eden-alert';

import { ICheckoutSectionContainerItem, ICheckoutSectionContainerViewProps } from './lds-checkout-section-container-4';

import { churchValidatePaymentAsync, churchSalesTaxGroupAsync, getRetailChannelAsync } from '../../actions/DataActionExtension.g';

interface ICheckoutSectionContainerItemExtended extends ICheckoutSectionContainerItem {
    isVisible?: boolean;
    userCountry?: string;
    resources?: any;
}

interface Option {
    value: string;
    label: string;
    billingEntity: IChurchUnitBillingEntity;
}

// const ItemComponent: React.FC<ICheckoutSectionContainerItemExtended> = ({ loading, itemProps, item }) => (
//     <>
//         {loading}
//         <Node {...itemProps}>{item}</Node>
//     </>
// );

const ItemComponent: React.FC<ICheckoutSectionContainerItemExtended> = ({
    loading,
    itemProps,
    item,
    isVisible,
    userCountry,
    resources
}) => {
    return (
        <>
            {loading}
            <Node {...itemProps} style={{ display: isVisible ? 'block' : 'none' }}>
                {userCountry === 'KOR' &&
                resources &&
                item &&
                // @ts-ignore
                item.props &&
                // @ts-ignore
                item.props.config &&
                // @ts-ignore
                item.props.config.paymenTenderType === 'KCP' &&
                itemProps &&
                itemProps.className === 'ms-checkout-section-container__item initialized ready' ? (
                    <h3 style={{ paddingTop: '10px' }}>{resources.kcpPaymentText}</h3>
                ) : (
                    ''
                )}
                {item}
            </Node>
        </>
    );
};

const CheckoutSectionContainerView: React.FC<ICheckoutSectionContainerViewProps> = props => {
    const { checkoutPlainContainerProps, items, paymentTypes, updatePaymentAttributes, resources, context } = props;
    // const [paymentSelected, setPaymentSelected] = React.useState(false);
    const [selectDisabled, setSelectDisabled] = React.useState(true);
    const [cartCheck, setCartCheck] = React.useState(false);
    const [paymentType, setPaymentType] = React.useState<Option | null>();
    const [retailChannel, setRetailChannel] = React.useState<IChurchRetailChannelEntity | null>();

    const userEmail = sessionStorage.getItem('email');
    React.useEffect(() => {
        sessionStorage.setItem('MercadoPago', 'false');
    }, []);

    const userCountry: any =
        // @ts-ignore
        props.data.cart && props.data.cart.result && props.data.cart.result.ExtensionProperties
            ? // @ts-ignore
              props.data.cart.result.ExtensionProperties.filter((property: any) => {
                  return property.Key === 'Country';
              })
            : '';

    const options: Option[] = [];
    let delieveryType: string;
    let filterPayments: boolean = false;
    if (
        props &&
        props.data &&
        // @ts-ignore
        props.data.cart &&
        // @ts-ignore
        props.data.cart.result &&
        // @ts-ignore
        props.data.cart.result.CartLines &&
        // @ts-ignore
        props.data.cart.result.CartLines[0]
    ) {
        // @ts-ignore
        delieveryType = props.data.cart.result.CartLines[0].DeliveryMode;
    }
    if (paymentTypes && paymentTypes.length > 0) {
        paymentTypes.map((type: any) => {
            if (type.CPBPICKUPONLY === 1) {
                filterPayments = true;
            }
        });
    }
    paymentTypes?.forEach(type => {
        // tendertypeId === 4 Pay in Store.
        // tendertypeId === 101/4 unit charge.
        // tendertypeId === 7 credit card.
        // tendertypeId === 100 debit card.

        // Check if the user is verified and if there are allowed payment types
        const isUserVerified =
            userEmail !== '' &&
            props.config.verifiedUsers?.length &&
            props.config.verifiedUsers?.length > 0 &&
            props.config.testingTenderTypes?.length &&
            props.config.testingTenderTypes?.length > 0;

        // Determine if the current payment type is allowed for the user
        const allowedPaymentType = props.config.testingTenderTypes?.some(tenderTypeId => tenderTypeId.tenderTypeId === type.TENDERTYPEID);

        // Check if the user is verified
        const isVerifiedUser = props.config.verifiedUsers?.some(
            user =>
                user.email?.toLocaleLowerCase() === userEmail?.toLocaleLowerCase() ||
                user.userId === props.context.request.user.customerAccountNumber
        );

        const getRetailChannel = async () => {
            const ctx = { callerContext: props.context.actionContext };

            // @ts-ignore
            const channel = await getRetailChannelAsync(ctx, props.context.request.channel?.RecordId);

            setRetailChannel(channel);
        };

        React.useEffect(() => {
            void getRetailChannel();
        }, []);

        // Function to add payment option based on delivery type and CPBPICKUPONLY flag

        const addPaymentOption = async () => {
            const option: Option = { label: type.PAYMENTMETHOD || '', value: type.PAYMENTMETHOD || '', billingEntity: type };

            const isPickupDelivery = ['PICKUP', 'Pickup', 'Curbside', 'CURBSIDE'].includes(delieveryType);
            const isJapanPickup = userCountry[0].Value.StringValue === 'JPN' && isPickupDelivery;
            const isJapanOrPhlDelivery =
                userCountry[0].Value.StringValue === 'JPN' || (userCountry[0].Value.StringValue === 'PHL' && !isPickupDelivery);

            if (filterPayments && retailChannel?.FilterPaymentMethods === 1) {
                const isPickupOnly = type.CPBPICKUPONLY === 1;
                const isNotPickupOnly = type.CPBPICKUPONLY === 0;
                if ((isPickupDelivery && isPickupOnly) || (!isPickupDelivery && isNotPickupOnly)) {
                    options.push(option);
                }
            } else if (isJapanPickup) {
                if (option.billingEntity.TENDERTYPEID !== '27') {
                    options.push(option);
                }
            } else if (isJapanOrPhlDelivery) {
                if (option.billingEntity.TENDERTYPEID !== '104') {
                    options.push(option);
                }
            } else {
                options.push(option);
            }
        };

        // Add payment options based on user verification and payment type
        if (isUserVerified) {
            if (isVerifiedUser && type.TENDERTYPEID !== '4') {
                void addPaymentOption();
            } else if (type.TENDERTYPEID !== '4' && !allowedPaymentType) {
                void addPaymentOption();
            }
        } else if (type.TENDERTYPEID !== '4') {
            void addPaymentOption();
        }
    });

    const onChange = async (option: Option | null) => {
        const ctx = { callerContext: context.actionContext };
        // @ts-ignore
        const cartId = props.data.checkout.result.checkoutCart.cart.Id || '';
        // @ts-ignore
        const cartVersion = props.data.checkout.result.checkoutCart.cart.Version || 0;
        // setPaymentSelected(true);
        setSelectDisabled(true);
        sessionStorage.setItem('paymentTypeId', option?.billingEntity.TENDERTYPEID || '');

        const isPaymentValid = await churchValidatePaymentAsync(ctx, cartId, cartVersion, Number(option?.billingEntity.TENDERTYPEID)).catch(
            (error: any) => {
                console.log(error);
                setCartCheck(true);
            }
        );

        if (isPaymentValid && isPaymentValid.RESULT === false) {
            setCartCheck(true);
        } else if (isPaymentValid && isPaymentValid.RESULT === true && cartCheck === true) {
            setCartCheck(false);
        }
        const paymentUpdates = await updatePaymentAttributes(option?.billingEntity);

        if (paymentUpdates) {
            setSelectDisabled(false);
        }
        let response;
        // @ts-ignore
        const checkoutState = props.data.checkout.result as ICheckoutState;
        const updatedTaxGroupAddress: any = checkoutState.shippingAddress;

        if (
            // @ts-ignore
            props.data.cart &&
            // @ts-ignore
            props.data.cart.result &&
            // @ts-ignore
            props.data.cart.result.CustomerId &&
            option &&
            option.billingEntity &&
            option.billingEntity.TENDERTYPEID
        ) {
            response = await churchSalesTaxGroupAsync(
                ctx,
                userCountry[0].Value.StringValue,
                // @ts-ignore
                props.data.cart.result.CustomerId,
                option?.billingEntity.TENDERTYPEID
            );
        }
        if (updatedTaxGroupAddress && checkoutState && checkoutState.shippingAddress && response && response.TaxGroup) {
            // updatedTaxGroupAddress.TaxGroup = option?.billingEntity.TENDERTYPEID === '101' ? 'NTX' : response.SalesTaxGroup;
            const updateCartDeliverySpecificationInput = {
                deliveryModeId: checkoutState.checkoutCart.cart.DeliveryMode || 'SD',
                shippingAddress: updatedTaxGroupAddress
            };
            if (response.TaxGroup !== checkoutState.shippingAddress.TaxGroup) {
                updatedTaxGroupAddress.TaxGroup = response.TaxGroup;
                await checkoutState.checkoutCart.updateCartDeliverySpecification(updateCartDeliverySpecificationInput).catch((err: any) => {
                    return console.log(err);
                });
            }
        }
        setPaymentType(option);
    };

    const isVisible = (id: string, name?: string) => {
        if (paymentType) {
            if (
                (paymentType.billingEntity.TENDERTYPEID === '7' ||
                    paymentType.billingEntity.TENDERTYPEID === '100' ||
                    paymentType.billingEntity.TENDERTYPEID === '103' ||
                    paymentType.billingEntity.TENDERTYPEID === '107' ||
                    paymentType.billingEntity.TENDERTYPEID === '102') &&
                // @ts-ignore
                id.includes('checkout-customer-account-payment' || 'lds-checkout-customer-account-payment')
            ) {
                return false;
            } else if (
                paymentType.billingEntity.TENDERTYPEID !== '7' &&
                paymentType.billingEntity.TENDERTYPEID !== '100' &&
                paymentType.billingEntity.TENDERTYPEID !== '103' &&
                paymentType.billingEntity.TENDERTYPEID !== '107' &&
                paymentType.billingEntity.TENDERTYPEID !== '102' &&
                // @ts-ignore
                id.includes('checkout-payment-instrument' || 'lds-checkout-payment-instrument')
            ) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };
    const termsAndConditions = items.filter((item: any) => {
        return item.id.includes('checkout-terms-and-conditions');
    });

    const paymentOptions = items.filter((item: any) => {
        return !item.id.includes('checkout-terms-and-conditions');
    });

    React.useEffect(() => {
        // @ts-ignore
        if (props.data.checkout && props.data.checkout.result) {
            // @ts-ignore
            setSelectDisabled(!props.data.checkout.result.isTermsAndConditionAccepted);
        }
    }, [props]);
    return (
        <Module {...checkoutPlainContainerProps}>
            {/* {items.map(item => (
                    <ItemComponent key={item.id} {...item} />
                ))} */}
            {termsAndConditions[0].item}
            <p style={{ fontSize: '14px' }}>
                {/* {shouldShowLocalCurrency && format(resources.currencyFeeMessage, context.cultureFormatter.currencyCode)} */}
                <Info>
                    <div style={{ paddingTop: '3px' }}>
                        {/* @ts-ignore */}
                        {format(props.resources.currencyFeeMessage, props.context.cultureFormatter.currencyCode)}
                    </div>
                </Info>
            </p>
            <Select
                defaultValue={paymentType}
                placeholder={resources.paymentTypeDropdownLabel}
                onChange={onChange}
                options={options}
                isDisabled={selectDisabled}
            />
            {cartCheck && <Error style={{ marginTop: '10px' }}>{resources.cartErrorMessage}</Error>}
            {!cartCheck &&
                paymentOptions.map((item: any, index: number) => {
                    let itemName;
                    // @ts-ignore
                    if (item && item.item && item.item.props && item.item.props.friendlyName) {
                        // @ts-ignore
                        itemName = item.item.props.friendlyName;
                    } else {
                        itemName = '';
                    }
                    return (
                        <ItemComponent
                            key={item.id}
                            {...item}
                            isVisible={isVisible(item.id, itemName)}
                            userCountry={''}
                            resources={resources}
                        />
                    );
                })}
        </Module>
    );
};

export default CheckoutSectionContainerView;
